import React, { useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import OGAMilestoneTable from './components/OGAMilestoneTable';
import MileStoneAchievmentTable from './components/MileStoneAchievmentTable';
import dayjs from 'dayjs';
import DatePickerCustom from '../../../../components/DatePicker/DatePickerCustom';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getOGAMilestone } from '../../../../redux/features/poinTrackerSlice';
import { Grid } from '@mui/material';

const OgaMilestoneLanding = () => {
  const [ogaFromdate, setOgaFromdate] = useState(dayjs().startOf('month').format('YYYY-MM-DD'));
  const [ogaToDate, setOgaToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const [ogaSelectedTeam, setOgaSelectedTeam] = useState({ id: -1, value: 'All' });

  const dispatch = useDispatch();
  const { loading, responseData } = useSelector((state) => state.pointTracker.ogaMileStone);

  const dispatchParams = useMemo(() => {
    return {
      fromDate: ogaFromdate,
      toDate: ogaToDate,
      wingId: ogaSelectedTeam?.id === -1 ? null : ogaSelectedTeam?.id,
    };
  }, [ogaFromdate, ogaToDate, ogaSelectedTeam?.id]);

  useEffect(() => {
    dispatch(getOGAMilestone(dispatchParams));
  }, [dispatch, dispatchParams]);

  return (
    <GlobalWrapper title={'OGA Milestone'}>
      <Grid container spacing={{ xs: 1 }}>
        {/* <Grid item xs={6} md={3} mb={2}>
          <DatePickerCustom
            label="Month"
            value={dayjs(ogaFromdate)}
            setValue={(date) => {
              // setSelectedMonth(date.format('YYYY-MM'));

              setOgaFromdate(dayjs(date).startOf('month').format('YYYY-MM-DD'));
              setOgaToDate(dayjs(date).endOf('month').format('YYYY-MM-DD'));
            }}
            viewDetails={['year', 'month']}
            fullWidth
            dateDisplayFormat="MM-YYYY"
          />
        </Grid> */}
      </Grid>
      <OGAMilestoneTable loading={loading} responseData={responseData} />
      <MileStoneAchievmentTable loading={loading} responseData={responseData} />
    </GlobalWrapper>
  );
};

export default OgaMilestoneLanding;
